import { Button, Modal } from "@myob/myob-widgets";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { useState } from "react";

import * as actions from "../store/actions/newTimesheetActions";

interface Props {
  show: Boolean;
  onCancel: Function;
  deleteTimesheet: Function;
  userId: string;
  timesheetId: string;
  closeRow: Function;
}


export const DeleteTimesheetModal = (props: Props) => {
  const {
    show, onCancel, timesheetId, deleteTimesheet, userId, closeRow,
  } = props;

  const [disabled, setDisabled] = useState(false);

  if (!show) { return null; }


  const callDeleteTimesheet = async () => {
    setDisabled(true);
    await deleteTimesheet(userId, timesheetId);
    setDisabled(false);
    onCancel();
    closeRow();
  };

  return (
    <Modal
      size="medium"
      show={show}
      onCancel={onCancel}
      title="Delete Timesheet"
    >
      <Modal.Body>
        <p>Are you sure you wish to delete this timesheet?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="secondary"
          id="modalCancelDeleteButton"
          onClick={() => onCancel()}
        >
          Cancel
        </Button>
        <Button
          id="modalDeleteButton"
          type="delete"
          disabled={disabled}
          onClick={() => (disabled ? {} : callDeleteTimesheet())}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    deleteTimesheet: actions.deleteTimesheet,
  },
  dispatch,
);

export default connect(
  null, mapDispatchToProps,
)(DeleteTimesheetModal);
